import type { SVGProps } from 'react';

const SvgMoveTop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12.71 8.272a.996.996 0 0 0-1.41 0l-3 3a.996.996 0 1 0 1.41 1.41l1.29-1.29v5.59c0 .55.45 1 1 1s1-.45 1-1v-5.59l1.29 1.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41z"
    />
    <path
      fill="currentcolor"
      d="M16 5.982H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgMoveTop;
